/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import { useOptionalAIAgentMessage } from '../../AIAgentMessage/context';
import './DeflectionRendererStyles.scss';
export function DeflectionRenderer({ block }) {
    var _a, _b, _c, _d;
    const deflection = block;
    const agentMessage = useOptionalAIAgentMessage();
    const hasIntercomSuggestedAction = (_b = (_a = agentMessage === null || agentMessage === void 0 ? void 0 : agentMessage.envelope.suggested_actions) === null || _a === void 0 ? void 0 : _a.some((action) => action.action === 'open_intercom')) !== null && _b !== void 0 ? _b : false;
    const hasZendeskTicketBlock = (_d = (_c = agentMessage === null || agentMessage === void 0 ? void 0 : agentMessage.envelope.blocks) === null || _c === void 0 ? void 0 : _c.some((sibling) => sibling.type === 'zendesk_ticket')) !== null && _d !== void 0 ? _d : false;
    const handleSupportLink = useCallback(() => {
        if (deflection.support_url) {
            window.open(deflection.support_url, '_blank', 'noopener,noreferrer');
        }
    }, [deflection.support_url]);
    // Three-way mutual exclusion. Both conditions mean the same thing: a more specific,
    // already-actioned escalation surface exists in this turn, so the deflection's own
    // generic "Get Support" link would be a second, unrelated CTA competing for the same
    // click. An `open_intercom` suggested action is the incumbent case; a sibling
    // `zendesk_ticket` block is the Support Agent case (a ticket the customer has already
    // been emailed about — pointing them at a support form as well is worse than useless).
    const supportAction = deflection.support_url && !hasIntercomSuggestedAction && !hasZendeskTicketBlock
        ? [
            {
                id: 'support',
                label: deflection.support_label || 'Get Support',
                icon: 'fa-light fa-life-ring',
                onClick: handleSupportLink
            }
        ]
        : [];
    // No heading. `category` is a routing key (`nfpa_content`, `feature_not_enabled`, `other`) kept on
    // the block for analytics, not copy — rendering it showed customers the internal tag as a header.
    const sections = [
        {
            content: React.createElement(Text, { variant: "body" }, deflection.message),
            copyText: deflection.message
        },
        ...(deflection.examples.length > 0
            ? [
                {
                    content: (React.createElement("div", { className: "qmb-ui-DeflectionRenderer__examples" },
                        React.createElement(Text, { variant: "body" }, "Try asking:"),
                        React.createElement("ul", { className: "qmb-ui-DeflectionRenderer__example-list" }, deflection.examples.map((example, i) => (React.createElement("li", { key: i },
                            React.createElement(Text, { variant: "body" }, example)))))))
                }
            ]
            : [])
    ];
    return (React.createElement(AIGeneralBlockCard, { sections: sections, footerGroups: supportAction.length > 0 ? [{ actions: supportAction }] : [] }));
}
